import React from "react";
import {selectUser} from "store/auth/selectors";
import {useSelector} from "react-redux";
import {Roles} from "@evennt-tech/api-v2-core";
import SupplierBar from "./components/SupplierBar/index";
import OrganiserBar from "./components/OrganiserBar";

const StripeConnectBar = () => {
  const {role} = useSelector(selectUser);

  if (!role) return null;

  if (![Roles.ORGANISER, Roles.SUPPLIER].includes(role)) {
    return null;
  }

  return role === Roles.SUPPLIER ? <SupplierBar /> : <OrganiserBar />;
};

export default StripeConnectBar;
